// extracted by mini-css-extract-plugin
var _1 = "PostModalViewTOC-module__animateUploadProgressBarWidth--m3Ax9";
var _2 = "PostModalViewTOC-module__animatedBackground--duzhi";
var _3 = "PostModalViewTOC-module__title--NOAsr";
var _4 = "PostModalViewTOC-module__tocContainer--FVWnM";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "title", _4 as "tocContainer" }
